import { EditPrivacyPolicy } from '@/admin/components/privacyPolicyPost/EditPrivacyPolicy';
import { PrivacyPoliciesProvider } from '@/admin/providers';

export const EditPrivacyPoliciesPage = () => (
  <PrivacyPoliciesProvider>
    <EditPrivacyPolicy />
  </PrivacyPoliciesProvider>
);
